'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/ScotchDoubleHorizontal.scss';
import ScotchDoubleSkin from './ScotchDoubleSkin';

const ScotchDoubleHorizontalSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <ScotchDoubleSkin {...props} skinsStyle={skinsStyles} />;

const ScotchDoubleHorizontal: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={ScotchDoubleHorizontalSkin} />
);

export default ScotchDoubleHorizontal;
